import React, { useEffect, useState } from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Paper, Breadcrumbs, CircularProgress, Alert, Table, TableBody, TableCell, TableRow, Button } from '@mui/material';
import { apiService } from '../services/apiService';

const ComplaintDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [complaint, setComplaint] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    setError(null);
    apiService.getComplaintDetail(Number(id))
      .then(res => setComplaint(res.data))
      .catch(err => setError(err.message || 'Failed to load complaint'))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', mt: 4 }}>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
        <RouterLink to="/app/contacts">Contacts</RouterLink>
        <RouterLink to="/app/contacts?tab=complaints">Complaints</RouterLink>
        <Typography color="text.primary">Complaint #{id}</Typography>
      </Breadcrumbs>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>Complaint Detail</Typography>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : complaint ? (
          <Table>
            <TableBody>
              {Object.entries(complaint).map(([key, value]) => (
                <TableRow key={key}>
                  <TableCell sx={{ fontWeight: 600, width: 220 }}>{key}</TableCell>
                  <TableCell sx={{ wordBreak: 'break-all' }}>{typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : null}
        <Box sx={{ mt: 3 }}>
          <Button component={RouterLink} to="/app/contacts?tab=complaints" variant="outlined">Back to Complaints</Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default ComplaintDetail; 